<template>
  <general-tour
    name="AttendanceListTour"
    :steps="steps"
  />
</template>

<script>
import GeneralTour from '../../../shared/tour/GeneralTour'

export default {
  name: 'AttendanceListTour',
  components: { GeneralTour },

  props: {
    hasIcons: { required: true },
  },

  data () {
    return {
      window,
      small: 767,
    }
  },
  computed: {

    targetAdditional () {
      return this.window.width < this.small ? '[data-v-step="additional_small"]' : '[data-v-step="additional"]'
    },

    steps () {
      let steps = [
        {
          target: '[data-v-step="general"]',
          content: Lang.get('attendance_list.tour.welcome'),
          offset: top,
          params: {
            placement: 'bottom',
          },
        },
        {
          target: '[data-v-step="row"]',
          content: Lang.trans('attendance_list.tour.mark_attended'),
          offset: top,
          params: {
            placement: 'top',
          },
        },
        {
          target: '[data-v-step="all_students"]',
          content: Lang.trans('attendance_list.tour.select_all'),
          offset: -200,
          params: {
            placement: 'bottom',
          },
        },
      ]

      if (this.hasIcons == true) {
        steps = steps.concat([
          {
            target: '[data-v-step="additional_info"]',
            content: Lang.trans('attendance_list.tour.additional_contexts'),
            offset: -400,
            params: {
              placement: 'left',
            },
          },
        ])
      }

      steps = steps.concat([
        {
          target: '[data-v-step="photopage"]',
          content: Lang.trans('attendance_list.tour.photo_page'),
          offset: -200,
          params: {
            placement: 'left',
          },
        },
        {
          target: '[data-v-step="attendances"]',
          content: Lang.trans('attendance_list.tour.number_attendances'),
          params: {
            placement: 'top',
          },
        },
        {
          target: this.targetAdditional,
          content: Lang.trans('attendance_list.tour.add_student'),
          params: {
            placement: 'top',
          },
        },
        {
          target: '[data-v-step="save_time"]',
          content: Lang.trans('attendance_list.tour.last_saved'),
          offset: -200,
          params: {
            placement: 'top',
          },
        },
      ])

      return steps
    },
  },
}
</script>
